/* globals google */
'use strict';

var base = require('base/storeLocator/storeLocator');
var shippingHelpers = require('../checkout/shipping');
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}
/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var mapMobile;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(-34.604713, -58.434290);

    map = new google.maps.Map($('#map-canvas-pickup')[0], {
        zoom: 4,
        center: latlng,
        mapId: 'map-canvas-pickup'
    });
    mapMobile = new google.maps.Map($('#map-canvas-pickup-mobile')[0], {
        zoom: 4,
        center: latlng,
        mapId: 'map-canvas-pickup-mobile'
    });
    var mapdiv = $('#map-canvas-pickup').attr('data-locations');
    var mapdivMobile = $('#map-canvas-pickup-mobile').attr('data-locations');
    mapdiv = JSON.parse(mapdiv);
    mapdivMobile = JSON.parse(mapdivMobile);
    var bounds = new google.maps.LatLngBounds();


    var mapdivKeys = Object.keys(mapdiv);
    var mapdivKeysMobile = Object.keys(mapdivMobile);
    var filteredForVisualRenderInMap = false;
    mapdivKeys.forEach(function (key) {
        var item = mapdiv[key];
        if (item.filteredForVisualRenderInMap) {
            filteredForVisualRenderInMap = true;
        }
    });

    mapdivKeys.forEach(function (key) {
        var item = mapdiv[key];
        // var label = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(
            item.latitude,
            item.longitude
        );

        var customMarkerIcon = document.createElement('img');
        customMarkerIcon.classList.add('custom-map-marker-icon');

        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: storeLocation,
            title: item.name,
            content: customMarkerIcon
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            let selectRadioButton = $(`#input-${item.ID}`);
            let selectStoreButton = $('.select-store');
            var resultsContainer = selectRadioButton.closest('.results');
            $('input[name="store"]').attr('checked', false);
            var cardBodyContainer = selectRadioButton.closest('.form-check');
            var scrollTo = cardBodyContainer.position().top + resultsContainer.scrollTop();
            resultsContainer.animate({
                scrollTop: scrollTo
            }, 300);
            selectStoreButton.attr('disabled', false);
            selectRadioButton.attr('checked', true);
        });
        customMarkerIcon.addEventListener('click', function () {
            customMarkerIcon.classList.add('bounce-marker');
        });

        customMarkerIcon.addEventListener('animationend', function () {
            customMarkerIcon.classList.remove('bounce-marker');
        });

        // Create a minimum bound based on a set of storeLocations
        //  This bounding box can be used to ensure that all specified points are visible within a map's viewport. .
        // Each marker is included in the bound, so all are going to be displayed
        if (!filteredForVisualRenderInMap) {
            bounds.extend(marker.position);
        } else if (item.filteredForVisualRenderInMap) {
            bounds.extend(marker.position);
        }
    });

    mapdivKeysMobile.forEach(function (key) {
        var item = mapdivMobile[key];
        // var label = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(
            item.latitude,
            item.longitude
        );

        var customMarkerIcon = document.createElement('img');
        customMarkerIcon.classList.add('custom-map-marker-icon');
        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: mapMobile,
            position: storeLocation,
            title: item.name,
            content: customMarkerIcon
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(mapMobile, marker);
            let selectRadioButton = $(`#input-${item.ID}`);
            let selectStoreButton = $('.select-store');
            var resultsContainer = selectRadioButton.closest('.results');
            $('input[name="store"]').attr('checked', false);
            var cardBodyContainer = selectRadioButton.closest('.form-check');
            var scrollTo = cardBodyContainer.position().top + resultsContainer.scrollTop();
            $('.store-locator-modal').animate({
                scrollTop: scrollTo
            }, 300);
            selectStoreButton.attr('disabled', false);
            selectRadioButton.attr('checked', true);
        });

        customMarkerIcon.addEventListener('click', function () {
            customMarkerIcon.classList.add('bounce-marker');
        });

        customMarkerIcon.addEventListener('animationend', function () {
            customMarkerIcon.classList.remove('bounce-marker');
        });

        // Create a minimum bound based on a set of storeLocations
        //  This bounding box can be used to ensure that all specified points are visible within a map's viewport. .
        // Each marker is included in the bound, so all are going to be displayed
        if (!filteredForVisualRenderInMap) {
            bounds.extend(marker.position);
        } else if (item.filteredForVisualRenderInMap) {
            bounds.extend(marker.position);
        }
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }

    if (mapdivMobile && mapdivMobile.length !== 0) {
        mapMobile.fitBounds(bounds);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */

function toggleSeeMoreButton() {
    if ($('#postalCodeSearchInput').val() > 0) {
        $('.see-all-stores').addClass('shown-button');
    } else {
        $('.see-all-stores').removeClass('shown-button');
    }
}

function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('#map-canvas-pickup');
    var $mapDivMobile = $('#map-canvas-pickup-mobile');
    var hasResults = data.stores.length > 0;
    if (!hasResults) {
        $('.store-locator-no-results').removeClass('d-none');
    } else {
        $('.store-locator-no-results').addClass('d-none');
    }
    $resultsDiv
        .empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);
    $mapDivMobile.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }
    if ($mapDivMobile.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
        $('.store-map-link').on('click', function () {
            var clickStoreNameGtm = {
                event: 'trackEvent',
                eventCategory: 'cta',
                eventAction: 'click en link de sucursal',
                eventLabel: $(this).prop('innerText')
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(clickStoreNameGtm);
        });
        $('.storelocator-phone').on('click', function () {
            var clickStoreNameGtm = {
                event: 'trackEvent',
                eventCategory: 'cta',
                eventAction: 'click en teléfono de sucursal',
                eventLabel: $(this).prop('innerText')
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(clickStoreNameGtm);
        });
    }
}

$('.open-locator').on('click', function () {
    var actualCP = $('.storeLocator-cp-input').val();
    setTimeout(function () {
        $('.input-cp-modal').val(actualCP);
    }, 1500);
});

function search(element) {
    var $storeLocatorModal = element.closest('.modal');
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };

    var shipmentUUID = $storeLocatorModal.attr('shipmentuuid');

    var payload = { postalCode: $form.find('[name="postalCode"]').val(), shipmentUUID: shipmentUUID };

    url = appendToUrl(url, urlParams);

    /**
     * DAB-4756  BEGIN Find store with postal code Google Tag Manager
     */
    var storesGtmEvent = {
        event: 'trackEvent',
        eventCategory: 'cta',
        eventAction: 'buscador codigo postal',
        eventLabel: $form.find('[name="postalCode"]').val()
    };
    if (storesGtmEvent.eventLabel !== null && storesGtmEvent.eventLabel !== '') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(storesGtmEvent);
    }
    /**
     * DAB-4756  END
     */
    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            toggleSeeMoreButton();
            $('.select-store').prop('disabled', true);
            var isCheckout = $('[name="ischeckout"]').length > 0;
            if (isCheckout) {
                $('.select-store-input').show();
                $('.store-details .result-number').hide();
            }
        }
    });
    return false;
}

// Sends the store info chosen by the user to the backend and receives the data with the dynamic price by postal code, updating the checkout.
function storeShippingPriceByPostalCode(data) {
    data.shipmentUUID = $('.shipping-form input[name="shipmentUUID"]').val();
    var storeUrl = $('.custom-pricing').data('price');
    $('body').trigger('checkout:beforeShippingMethodSelected');
    $.spinner().start();

    $.ajax({
        url: storeUrl,
        method: 'GET',
        dataType: 'json',
        data: data,
        success: function (res) {
            if (res.error) {
                window.location.href = res.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: res.order,
                        customer: res.customer
                    }
                );
                $('body').trigger('checkout:shippingMethodSelected', res);
                $.spinner().stop();
            }
        },
        error: function (err) {
            if (err.redirectUrl) {
                window.location.href = err.redirectUrl;
            }
            $.spinner().stop();
        }
    });
}

base.init = function () {
    $('body').on('store:selected', function (e, data) {
        var storeLocatorModal = $('#storeLocatorModal');
        var isMulti = storeLocatorModal.attr('ismulti');
        var form;
        if (isMulti) {
            var pliUUIDInput = $('[value=' + storeLocatorModal.attr('productlineitemuuid') + ']');
            form = pliUUIDInput[0].form;
        } else {
            var shipmentSelectorDefualt = $('#shipmentSelector-default');
            form = (shipmentSelectorDefualt.length !== 0) ? shipmentSelectorDefualt[0].form : null;
        }
        if (form) {
            var fieldSet = $('.pickup-in-store', form);
            var storeIdInput = fieldSet.find('[name="storeId"]');
            // var newLabel = $(data.storeDetailsHtml);
            var storeAddressNumber;
            if (data.storeInfo.custom && data.storeInfo.custom.number) {
                storeAddressNumber = data.storeInfo.custom.number;
            }
            $('.selected-store', form).find('.store-name').empty().append(data.storeInfo.name);
            $('.selected-store', form).find('.store-map').empty().append(data.storeInfo.address1 + ' ' + storeAddressNumber);
            $('.selected-store', form).find('.storelocator-phone').empty().append(data.storeInfo.phone);
            $('.selected-store', form).show();
            storeIdInput.val(data.storeID);

            if ($('#shipping-method-instore').is(':checked')) {
                storeShippingPriceByPostalCode(data.storeInfo);
            }
            // pickupInStorePanel.empty().append(content);
            // pickupInStorePanel.siblings('.change-store').removeClass('d-none');
            $('#inStoreInventoryModal').modal('hide');
        }
    });
    if ($('.open-locator')) {
        $('.open-locator').on('click', function (e) {
            e.preventDefault();
            var postalCodeInput = $(e.currentTarget).parent().find('#store');
            var storeLocatorModal = $('#storeLocatorModal');
            var modalPostalCodeInput = storeLocatorModal.find('#store-postal-code');
            var modalSearchButton = storeLocatorModal.parent().find('.btn-storelocator-search');
            var shipmentUUID = postalCodeInput.closest('.shipping-form').find('[name="shipmentUUID"]').val();
            if (postalCodeInput.closest('.shipping-form').find('[name="productLineItemUUID"]').length > 0) {
                var pliUUID = postalCodeInput.closest('.shipping-form').find('[name="productLineItemUUID"]').val();
                storeLocatorModal.attr('productLineItemUUID', pliUUID);
                storeLocatorModal.attr('isMulti', true);
            }
            var originalShipmentUUID = postalCodeInput.closest('.shipping-form').find('[name="originalShipmentUUID"]').val();
            modalPostalCodeInput.val(postalCodeInput.val());
            storeLocatorModal.attr('shipmentUUID', shipmentUUID);
            storeLocatorModal.attr('originalShipmentUUID', originalShipmentUUID);

            search(modalSearchButton);
        });
    }
    if ($('#map-canvas-pickup').data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (!$('.results').data('has-results')) {
        $('.store-locator-no-results').show();
    }
};

base.selectStore = function () {
    $('.store-locator-container').on('click', '.select-store', (function (e) {
        e.preventDefault();
        var selectedStore = $(':checked', '.results-card .results');
        var data = {
            storeID: selectedStore.val(),
            searchRadius: $('#radius').val(),
            searchPostalCode: $('.results').data('search-key').postalCode,
            storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
            storeInfo: JSON.parse(selectedStore.attr('data-store-info')),
            event: e
        };
        /**
        * DAB-4756 BEGIN - push datalayer Select store event Google Tag manager
        */
        var storeSelectedGtmEvent = {
            event: 'trackEvent',
            eventCategory: 'cta',
            eventAction: `sucursal: ${JSON.parse(selectedStore.attr('data-store-info')).name}`,
            eventLabel: `Id de sucursal: ${selectedStore.val()}`
        };
        if (selectedStore.attr('data-store-info') !== null && selectedStore.attr('data-store-info') !== '') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(storeSelectedGtmEvent);
        }
        /**
        * DAB-4756 END
        */
        $('button.submit-shipping').attr('disabled', false);
        $('body').trigger('store:selected', data);
    }));
};

base.detectLocation = function () {
    // clicking on detect location.
    $('.detect-location').on('click', function () {
        $.spinner().start();
        if (!navigator.geolocation) {
            $.spinner().stop();
            return;
        }
        var detectLocationGtm = {
            event: 'trackEvent',
            eventCategory: 'cta',
            eventAction: 'usar mi ubicación',
            eventLabel: $(this).attr('class')
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detectLocationGtm);
        navigator.geolocation.getCurrentPosition(function (position) {
            var $detectLocationButton = $('.detect-location');
            var url = $detectLocationButton.data('action');
            var radius = $('.results').data('radius');
            var shipmentUUID = $('#storeLocatorModal').attr('shipmentuuid');

            var urlParams = {
                radius: radius,
                lat: position.coords.latitude,
                long: position.coords.longitude,
                shipmentUUID: shipmentUUID
            };

            url = appendToUrl(url, urlParams);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $.spinner().stop();
                    toggleSeeMoreButton();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    });
};

base.changeRadius = function () {
    $('.store-locator-container .radius').change(function () {
        var radius = $(this).val();
        var searchKeys = $('.results').data('search-key');
        var url = $(this).data('action-url');
        var urlParams = {};

        if (searchKeys.postalCode) {
            urlParams = {
                radius: radius,
                postalCode: searchKeys.postalCode
            };
        } else if (searchKeys.lat && searchKeys.long) {
            urlParams = {
                radius: radius,
                lat: searchKeys.lat,
                long: searchKeys.long
            };
        }

        url = appendToUrl(url, urlParams);
        var dialog = $(this).closest('.in-store-inventory-dialog');
        var spinner = dialog.length ? dialog.spinner() : $.spinner();
        spinner.start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                spinner.stop();
                updateStoresResults(data);
                $('.select-store').prop('disabled', true);
            }
        });
    });
};

base.search = function () {
    $('.store-locator-container form.store-locator').submit(function (e) {
        e.preventDefault();
        search($(this));
    });
    $('.store-locator-container .btn-storelocator-search[type="button"]').click(
        function (e) {
            e.preventDefault();
            search($(this));
        }
    );
    var postalCodeInput = $('#store');
    postalCodeInput.on('keydown', function (e) {
        if (e.code === 'Enter') {
            $('.open-locator').trigger('click');
        }
    });
};

base.removeSelectedstore = function () {
    $('.selected-store-header i.fa-trash').on('click', function (e) {
        var shipping = {
            UUID: ''
        };
        var form = e.target.form;
        var shipmentUUID = $('input[name=shipmentUUID]', form).val();
        var fieldSet = $('.pickup-in-store', form);
        var selectedStoreHtml = $('.selected-store', form);

        shipping.UUID = shipmentUUID;
        shippingHelpers.methods.updateShippingAddressFormValues(shipping);
        fieldSet.find('[name="storeId"]').val('');
        selectedStoreHtml.find('.store-name').empty();
        selectedStoreHtml.find('.store-map').empty();
        selectedStoreHtml.find('.storelocator-phone').empty();
        selectedStoreHtml.hide();
    });
};

$('.see-all-stores').on('click', function () {
    if ($(this).hasClass('all-stores-shown')) {
        $(this).removeClass('all-stores-shown');
        if ($('.store-item').hasClass('to-hide')) {
            $('.store-item.to-hide').addClass('d-none');
        }
        $(this).text('Ver todas');
    } else {
        $(this).addClass('all-stores-shown');
        $('.store-item').removeClass('d-none');
        $(this).text('Ver menos');
    }
});

module.exports = base;
